import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.TEAM_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.TEAM_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const teamList = (params) => {
  return async (dispatch) => {
    dispatch({ type: CONST.TEAM_LIST_REQUEST });
    axios.get('/teams', { params: { ...params, per_page: 50 } }).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
